<template>
    <div>
        <el-row v-for="(item, index) in formData" :key="index">
            <el-col :span="3">
                <div style="position: relative;height: 40px;line-height: 40px;">
                    <template v-if="index === 0">
                        <span>{{ $t('operation.task.analyseTime') }}:</span>
                        <el-tooltip :content="$t('operation.task.analyseTimeTip')" placement="top">
                            <i class="el-icon-question" style="position: absolute;top:0;right:6px;"></i>
                        </el-tooltip>
                    </template>
                </div>
            </el-col>
            <el-col :span="10">
                <el-time-picker style="margin-bottom: 20px;width:240px;" is-range :clearable="false"
                    v-model="item.timePeriods" format="HH:mm:ss" value-format="HH:mm:ss" range-separator="-"
                    :start-placeholder="$t('common.startdate')" :end-placeholder="$t('common.enddate')"
                    @change="changeTimePeriods($event, index)"></el-time-picker>
            </el-col>
            <el-col :span="11">
                <span style="margin-right: 10px;">{{ $t('operation.task.scale') }}:</span>
                <el-input-number v-model="item.scale" :min="1" :max="100" :precision="0"
                    style="width: 130px;"></el-input-number>
                &nbsp;%

                <i class="el-icon-delete" style="margin-left: 10px;cursor:pointer;" v-if="index != 0"
                    @click="clickDeleteWorkTime(index)"></i>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="3"> &nbsp;</el-col>
            <el-col :span="10">
                <div :class="disabledAddTimeBtn ? 'sys-task-add disabled' : 'sys-task-add'" @click="clickAddWorkTime"> +
                </div>
            </el-col>
        </el-row>
    </div>

</template>

<script>
export default {
    data() {
        return {
            popupModal: false,
            actionType: 0, // 0:add 1:detail 2:update
            disabledAddTimeBtn: true,
            formData: []
        }
    },
    mounted() {

    },
    methods: {
        open(type, data) {
            this.actionType = type;
            if (data.length === 0) {
                data.push({
                    timePeriods: ['00:00:00', '23:59:59'],
                    scale: 10,
                });
            }
            this.formData = data;
            this.popupModal = true;
            this._isDisabledAddTimeBtn(data);
        },
        clickAddWorkTime() {
            if (this.disabledAddTimeBtn) {
                return
            }
            this.formData.push({ timePeriods: '', scale: 10 });
        },
        clickDeleteWorkTime(index) {
            this.formData.splice(index, 1);
            this.timeCrossFlag = false;
            this._isDisabledAddTimeBtn(this.formData)
        },
        changeTimePeriods(val, index) {
            this.currentTimePeriods = val;
            if (
                this.currentTimePeriods[0].length == 0 ||
                this.currentTimePeriods[0] == this.currentTimePeriods[1]
            ) {
                return;
            }
            if (this.formData.length > 1) {
                for (var i = 0; i < this.formData.length; i++) {
                    if (this.formData[i].timePeriods != '') {
                        const start1 = this.$moment(this.currentTimePeriods[0], 'HH:mm:ss');
                        const end1 = this.$moment(this.currentTimePeriods[1], 'HH:mm:ss');
                        const start2 = this.$moment(this.formData[i].timePeriods[0], 'HH:mm:ss');
                        const end2 = this.$moment(this.formData[i].timePeriods[1], 'HH:mm:ss');
                        if (
                            this.isTimeOverlap(start1, end1, start2, end2) && i !== index
                        ) {
                            this.formData[index].timePeriods = '';
                            this.$message.error(this.$t('operation.task.workOverlap'));
                            this.timeCrossFlag = true;

                            return;
                        }
                    }

                }
            }
            this.timeCrossFlag = false;
            this._isDisabledAddTimeBtn(this.formData)
        },
        isTimeOverlap(start1, end1, start2, end2) {
            if (start1.isAfter(end2) || start2.isAfter(end1)) {
                return false;
            }
            return true;
        },
        _isDisabledAddTimeBtn(list) {
            if (list.length === 0) {
                this.disabledAddTimeBtn = false;
                return
            }
            let len = list.length;
            if (list[0].timePeriods[0] !== '00:00:00') {
                this.disabledAddTimeBtn = false;
                return
            }
            if (list[len - 1].timePeriods[1] !== '23:59:59') {
                this.disabledAddTimeBtn = false;
                return
            }

            if (len === 1) {
                if (this.formData[0].timePeriods[0] === '00:00:00' && this.formData[0].timePeriods[1] === '23:59:59') {
                    this.disabledAddTimeBtn = true;
                    return
                }
            }
            let flag = true;
            for (let i = 0; i < len - 1; i++) {
                var time1 = list[i].timePeriods[1].split(':')
                var time2 = list[i + 1].timePeriods[0].split(':')
                let time1_stamp = time1[0] * 3600 + time1[1] * 60 + time1[2] * 1;
                let time2_stamp = time2[0] * 3600 + time2[1] * 60 + time2[2] * 1;
                if ((time1_stamp + 1) !== time2_stamp) {
                    flag = false;
                    this.disabledAddTimeBtn = false;
                    break
                }
            }
            if (flag) {
                this.disabledAddTimeBtn = true
            }
        },
        saveData() {
            return this.formData;
        },
    }
}
</script>

<style scoped></style>